export const LOGO_URL = "https://customer-assets.emergentagent.com/job_playworld-shop/artifacts/73mj3pom_Anthony%27s%20PlayWorld%20Logo.jpg";
export const YOUTUBE_URL = "https://youtube.com/@anthonysplayworld";
